export default __webpack_public_path__ + "static/1-9-0-0-753a1c5e0b3a5418ac54a2d7afada5c0.jpg";